import { devLog } from './devLogger';

/**
 * XBRL Mandatory Fields (matches 1.0 XBRLFieldHandler)
 * These fields MUST have a value - default to "0.00" if empty
 * Different from submission mandatory fields (asterisks)
 */
export const XBRL_MANDATORY_FIELDS = [

  // Malaysia Taxonomy

      // SOCIE
      "ifrs-full:NoncurrentInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
      "ifrs-full:NoncontrollingInterests",
      "ifrs-full:LiabilitiesIncludedInDisposalGroupsClassifiedAsHeldForSale",
      "ifrs-full:OtherNoncurrentAssets",
      "ifrs-full:OtherCurrentAssets",
      "ifrs-full:RetainedEarnings",
      "ssmt-mpers:OtherNoncurrentAssets",
      "ssmt-mpers:OtherCurrentAssets",
      "ifrs-smes:RetainedEarnings",
      "ifrs-smes:FinanceCosts",
      "ifrs-full:FinanceCosts",
      "ifrs-full:AdministrativeExpense",
      "ifrs-full:IncomeTaxExpenseContinuingOperations",
      "ifrs-smes:Equity",
      "ifrs-full:Equity",
      "ifrs-smes:AmountsPayableRelatedPartyTransactions",
      "ifrs-smes:AmountsReceivableRelatedPartyTransactions",
      "ssmt-mpers:OtherBalancesWithRelatedParties",
      "ifrs-full:AmountsReceivableRelatedPartyTransactions",
      "ifrs-full:AmountsPayableRelatedPartyTransactions",
      "ssmt-mfrs:OtherBalancesWithRelatedParties",
      "ssmt-mpers:ImpactOfChangeInAccountingStandards",
      "ssmt-mfrs:ImpactOfChangeInAccountingStandards",
      "ifrs-full:ProfitLoss",
      "ifrs-smes:ProfitLoss",
      "ifrs-full:OtherComprehensiveIncome",
      "ifrs-smes:OtherComprehensiveIncome",
      "ifrs-smes:ProfitLossAttributableToOwnersOfParent",
      "ifrs-full:ProfitLossAttributableToOwnersOfParent",
      "ifrs-smes:ProfitLossAttributableToNoncontrollingInterests",
      "ifrs-full:ProfitLossAttributableToNoncontrollingInterests",
      "ifrs-smes:ComprehensiveIncomeAttributableToNoncontrollingInterests",
      "ifrs-full:ComprehensiveIncomeAttributableToNoncontrollingInterests",
      "ifrs-smes:CashAndCashEquivalents",
      "ifrs-full:CashAndCashEquivalents",
      // CLBG
      "ssmt-mfrs:ContributionsFromMembers",
      "ifrs-full:NoncurrentProvisionsForEmployeeBenefits",
      "ifrs-full:NoncurrentProvisions",
      "ifrs-full:CurrentProvisionsForEmployeeBenefits",
      "ifrs-full:CurrentProvisions",
      "ifrs-full:DepreciationAmortisationAndImpairmentLossReversalOfImpairmentLossRecognisedInProfitOrLoss",
      "ssmt-mfrs:OtherPriorPeriodAdjustments",
      "ifrs-full:CashFlowsFromUsedInOperationsBeforeChangesInWorkingCapital",
      // SORE
      "ssmt-mpers:ImpactOfChangesInAccountingPolicies",

      // CLBS 1965
      "ssmt-1965:PropertyPlantAndEquipment",
      "ssmt-1965:Investments",
      "ssmt-1965:OtherNoncurrentAssets",
      "ssmt-1965:CurrentAssets",
      "ssmt-1965:CurrentLiabilities",
      "ssmt-1965:IssuedCapital",
      "ssmt-1965:SharePremiumAndReserve",
      "ssmt-1965:RetainedEarnings",
      "ssmt-1965:NoncontrollingInterests",
      "ssmt-1965:NoncurrentLiabilities",

      "ssmt-1965:Revenue",
      "ssmt-1965:ProfitLossBeforeTax",
      "ssmt-1965:ProfitLossAfterTax",
      "ssmt-1965:ProfitLossAttributableToNoncontrollingInterests",
      "ssmt-1965:Dividend",

      // CLBG 1965
      "ssmt-1965:NoncurrentAssets",
      "ssmt-1965:FundAndReserve",
      "ssmt-1965:Income",
      "ssmt-1965:Expenditure",
      "ssmt-1965:UnappropriatedProfitBroughtForward",


  // Singapore Taxonomy
      // SOFP core totals
      'sg-as:Assets',
      'sg-as:CurrentAssets',
      'sg-as:NoncurrentAssets',
      'sg-as:Liabilities',
      'sg-as:CurrentLiabilities',
      'sg-as:NoncurrentLiabilities',
      'sg-as:Equity',
    
      // SOPL core totals
      'sg-as:TaxExpenseBenefitContinuingOperations',
      'sg-as:ProfitLoss',
      'sg-as:ProfitLossAttributableToOwnersOfCompany',
      'sg-as:ProfitLossAttributableToNoncontrollingInterests',
    
      // SOCF required concepts
      'sg-as:CashFlowsFromUsedInOperatingActivities',
      'sg-as:CashFlowsFromUsedInInvestingActivities',
      'sg-as:CashFlowsFromUsedInFinancingActivities',

      //PPE & IA'
      'sg-as:IntangibleAssetsOtherThanGoodwillAtCost',
      'sg-as:PropertyPlantAndEquipmentAtCost',

      //selected expenses
      'sg-as:IncreaseDecreaseInInventoriesOfFinishedGoodsAndWorkInProgress',
      'sg-as:RawMaterialsAndConsumablesUsed',
      'sg-as:SubcontractorCost',
      'sg-as:DividendDeclaredDuringTheYear',
      'sg-as:OtherIncome',
      'sg-as:NetGainsLossesOnForeignExchangeAdjustment',
      'sg-as:NetGainsLossesOnDisposalOfPropertyPlantAndEquipment',
      'sg-as:NetGainsLossesOnDisposalOfIntangibleAssets',
      'sg-as:ImpairmentLossReversalOfImpairmentLossOnInvestments',
      'sg-as:ImpairmentLossReversalOfImpairmentLossOnReceivables',
      'sg-as:ImpairmentLossReversalOfImpairmentLossOnOthers',


      //right to use asset
      'sg-as:RightofuseAssetsClassifiedInPropertyPlantAndEquipment',
      'sg-as:RightofuseAssetsClassifiedInIntangibleAssetsOtherThanGoodwill',
      'sg-as:RightofuseAssetsClassifiedInOtherAssets'

];

/**
 * Check if a field is an XBRL mandatory field (must have value, default to 0.00)
 */
export const isXBRLMandatoryField = (qname: string): boolean => {
  return XBRL_MANDATORY_FIELDS.includes(qname);
};

/**
 * Initialize XBRL mandatory fields with "0.00" if empty
 */
export const initializeXBRLMandatoryFields = () => {
  XBRL_MANDATORY_FIELDS.forEach(qname => {
    const inputs = document.querySelectorAll(`input[data-qname="${qname}"]`);
    inputs.forEach(input => {
      if (input instanceof HTMLInputElement) {
        const value = input.value.trim();
        if (value === '') {
          input.value = '0.00';
        }
      }
    });
  });
  devLog('✅ Initialized XBRL mandatory fields with 0.00');
};

/**
 * Handle blur event - set to "0.00" if empty
 */
export const handleXBRLFieldBlur = (input: HTMLInputElement) => {
  const qname = input.getAttribute('data-qname');
  if (qname && isXBRLMandatoryField(qname)) {
    const value = input.value.trim();
    if (value === '') {
      input.value = '0.00';
      // Trigger change event for validation
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
};

